<template>
    <div>
        
        <div class="container">
            <Cabecera></Cabecera>
            <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/EditarPerfilUsuario">Editar perfil de Usuario</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <Menu/>
<div class="row">
    <div class="col s12 m12 l12">
      <div class="card">
        <div class="card-content  black-text">
          <span class="card-title">Actualizar perfil</span>
          <p>Instrucciones: Modificar un dato a la vez y presionar EDITAR</p>
          <form id="editarUsuario" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
            <input type="text" name="nombre" id="nombre" placeholder="Nombre" :value="formEditar.nombre" v-on:click=getId() >
             <input type="text" name="apellidos" id="apellidos" placeholder="Apellidos" :value="formEditar.apellidos" >
              <input type="text" name="telefono" id="telefono" placeholder="Teléfono" :value="formEditar.telefono" >
              
    <b-form-select v-model="selected" class="mb-3" placeholde="Perfil">
      <b-form-select-option value="Capturista">Capturista</b-form-select-option>
      <b-form-select-option value="Médico">Médico</b-form-select-option>
      <b-form-select-option value="Supervisor">Supervisor</b-form-select-option>
      <b-form-select-option value="Administrador" >Administrador</b-form-select-option>
     
    </b-form-select>


<div class="container" v-if="show1==100" >
        <div class="row">
            <div class="col-md-6">
                <h2>Current Camera</h2>
                <code v-if="device">{{ device.label }}</code>
                <div class="border">
                    <web-cam
                        ref="webcam"
                        :device-id="deviceId"
                        width="100%"
                        @started="onStarted"
                        @stopped="onStopped"
                        @error="onError"
                        @cameras="onCameras"
                        @camera-change="onCameraChange"
                    />
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <select v-model="camera">
                            <option>-- Select Device --</option>
                            <option
                                v-for="device in devices"
                                :key="device.deviceId"
                                :value="device.deviceId"
                            >{{ device.label }}</option>
                        </select>
                    </div>
                    <div class="col-md-12">
                        <button type="button" class="btn btn-primary" @click="onCapture">Capture Photo</button>
                        <button type="button" class="btn btn-danger" @click="onStop">Stop Camera</button>
   <button type="button" class="btn btn-success" @click="onStart">Start Camera</button>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h2>Captured Image</h2>
                <figure class="figure">
                    <img :src="img" class="img-responsive" />
                </figure>
            </div>
        </div>
    </div>
    

                <input type="text" id="avatar" name="avatar" accept="image/png, image/jpeg" v-model="img" v-if="show==100" >
                <input type="text" name="unidadVisible" id="unidadVisible" placeholder="Unidad" :value=formEditar.unidad>
                <input type="text" name="codigo" id="codigo" placeholder="Código" v-model="codigoUnidad" v-on:focus=validarUnidad() >
               <input type="hidden" name="email" id="email" placeholder="email" :value="formEditar.email" >
               <input type="hidden" name="perfil" id="perfil"  :value=selected >
               <input type="hidden" name="unidad" id="unidad"  :value=unidadCodigo >
               <input type="hidden" name="imagen" id="imagen"  :value=img >
            <div class="file-field input-field">
                <div class="btn">
                <span>Imagen de perfil</span>
                <input type="file" name="foto" multiple >
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>
            <br>
            <p>Anexos: Al anexar nuevos archivos los anteriore serán eliminados</p>
            <div class="file-field input-field">
                <div class="btn">
                <span>Evidencia</span>
                <input type="file" name="evidencia" multiple>
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text" >
                </div>
            </div>
            <br><br>

            <input type="submit" value="Editar" :class="boton">
            </form>
        </div>
        <div class="card-action">
          
         
        </div>
      </div>
    </div>
  </div>

</div> 
    </div>
</template>

<script>
import { WebCam } from "vue-web-cam"
import swal from 'sweetalert'
import axios from 'axios'
import Cabecera from './Cabecera'
import Menu from './Menu'
import sesion from '../mixins/sesion'
import eliminar from '../mixins/eliminar'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
    name:'EditarPerfilUsuario',
    data(){
        return{
            formEditar:{},
            pass:'',
        passC:'',
        respuesta:'',
        correo:'',
        boton:'btn blue enabled',
        usuariolocal:'',
        fotolocal:'',
        codigoUnidad:'',
        booleanCodigo:false,
        perfilCodigo:'',
        unidadCodigo:'',
        selected:null,

        img: null,
            camera: null,
            deviceId: null,
            devices: [],
            show1:1,
        
        }
        
    },
    components:{
    Cabecera,
    Menu,
    WebCam
  },
  created(){
      this.usuario()
       setTimeout(() => {  this.getId(); }, 500)
        
    },
    computed:{
      ...mapState(['usuarioActual','idActual','fotoActual']),
      device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        }
    },
    watch: {
        camera: function(id) {
            this.deviceId = id;
        },
        devices: function() {
            // Once we have a list select the first one
            const [first, ...tail] = this.devices;
            if (first) {
                this.camera = first.deviceId;
                this.deviceId = first.deviceId;
            }
        }

      
  },
  mounted() {
    this.video = this.$refs.video;
    if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
            this.video.src = window.URL.createObjectURL(stream);
            this.video.play();
        });
    }
},  
    methods:{
      onCapture() {
            this.img = this.$refs.webcam.capture();
        },
        onStarted(stream) {
            console.log("On Started Event", stream);
            
        },
        onStopped(stream) {
            console.log("On Stopped Event", stream);
        },
        onStop() {
            this.$refs.webcam.stop();
            this.show1=0
        },
        onStart() {
            this.$refs.webcam.start();
            this.show1=1
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
            console.log("On Cameras Event", cameras);
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
            console.log("On Camera Change Event", deviceId);
        },
        validarUnidad(){
          
          if(this.codigoUnidad=='rz929'){
            this.selected=this.perfilCodigo
            this.perfilCodigo='Capturista'
           this.unidadCodigo='Rastro de Zapopan'
            document.getElementById('unidadVisible').value=this.unidadCodigo
          
          }

        },
        usuario(){
        
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     //this.usuariolocal= result
     //const tok=this.usuariolocal
      const tok=result
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil

      })
        },
        getId(){
           //this.usuario()

            const id = this.usuariolocal
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+id)
            
                .then(response=>{
                   
                    this.formEditar = response.data
                  
                    this.selected=this.formEditar.perfil
                })
                   
        }, 
        editar(){
             const form=document.getElementById('editarUsuario')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/editarPerfilUsuario.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       // this.$router.push('/inicio')
                        swal('El registro fue editado')
                    } else {
                        swal('El post no pudo ser editado'+res.data)
                    }
                })
        },
        ////<h5>RES: {{respuesta}}</h5>
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
    },
    mixins:[sesion,eliminar],
    
}
</script>

<style scoped>

    
    #app {
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
    #video {
        background-color: #000000;
    }
    #canvas {
        display: none;
    }
    li {
        display: inline;
        padding: 5px;
    }

</style>


// WEBPACK FOOTER //
// src/components/EditarPerfilUsuario.vue